import React, {useEffect, useState} from 'react'
import {Field, InjectedFormProps, reduxForm} from 'redux-form'
import {FormSubmissionError, verifyChannelCode} from "../UserActions";
import {Dispatch} from "redux";
import {renderField} from "./form";
import {t} from "../../i18n";
import {AppState} from "../../RootReducer";
import {connect, useSelector} from "react-redux";
import {number} from "./utils";
import {getContainer} from "../../ioc/IOCSetup";
import {LoginVerification, ManualLoginRequest, ReCaptchaAction, Settings} from "../../http/protocol";
import {Redirect, useHistory, useRouteMatch} from "react-router";
import {BrandButton} from "../../ui/buttons/buttons";
import {executeCaptcha, isReCaptchaActionEnabled} from "../../ReCaptcha";
import { setModalPath } from '../../onboardingpage/modalview/utils';
import { LoginStatus, VerifyPrincipalStatus } from '../../http/Types';
import { isRedirectToVerifyPrincipal } from '../ui/utils'

const isValid = function (value : string | undefined, min : number = 0) : boolean {
    if(min == 0 && !value) {
        return false;
    } else if(!value || value.trim().length < min) {
        return false;
    } else {
        return true;
    }
}

interface Props extends InjectedFormProps {
    remoteError?: string;
    text?: string;
    manualLoginRequest?:ManualLoginRequest;
    verificationRequired?: any;
}


const validateVerifyEmailForm= (values : {verifyEmail?: string, verifyPhoneNumber?: string})=> {
    let error : any = {};

    if(!isValid(values.verifyEmail, 4)) {
        error.verifyEmail = t("forms.verifyEmail.required");
    }

    if(!number(values.verifyEmail)) {
        error.verifyEmail = t("forms.verifyEmail.invalid");
    }
    if(!isValid(values.verifyPhoneNumber, 4)) {
        error.verifyPhoneNumber = t("forms.verifyEmail.required");
    }

    if(!number(values.verifyPhoneNumber)) {
        error.verifyPhoneNumber = t("forms.verifyEmail.invalid");
    }

    return error;
}

const resendEmailVerificationCode = async (principal:string, verification : LoginVerification, settings?: Settings) => {
    setInterval(() => {

    }, 1000)
    const us = getContainer().getUserService();

    let captchaToken : string | undefined;

    if(isReCaptchaActionEnabled(ReCaptchaAction.requestPrincipalVerification, settings)) {
        try {
            captchaToken = await executeCaptcha(ReCaptchaAction.requestPrincipalVerification, settings?.reCaptchaSettings?.siteKey);
        } catch (e) {
            throw new FormSubmissionError(t("user.invalid-registration-details"));
        }
    }

    return us.requestVerificationPrincipal(principal, verification,captchaToken);
}

export const VerifyEmailForm = (props : Props) => {
    const history = useHistory();
    const [showResend, setShowResend] = useState(false);
    const [redirectToLogin, setRedirectToLogin] = useState(false);
    const [resendActive, setResendActive] = useState(true);
    const [principal, setPrincipal] = useState<string|undefined>("");
    const settings = useSelector((app : AppState) => app.settings.settings);
    const user = useSelector((app : AppState) => app.user);

    useEffect(() => {
        if(props && props.manualLoginRequest && (props.manualLoginRequest.email || props.manualLoginRequest.phoneNumber)) {
            setPrincipal(props.manualLoginRequest?.verification == LoginVerification.EMAIL ? props.manualLoginRequest.email : props.manualLoginRequest.phoneNumber);
        } else {
            //Email lost, redirect to login page!
            setRedirectToLogin(true)
        }

        const resendTO = setTimeout(() => {
            setShowResend(true);
        }, 30 * 1000)
        return () => clearTimeout(resendTO);
    }, [props.manualLoginRequest]);


    if(props && props.error && props.error.length > 0 && !showResend) {
        setShowResend(true);
    }
    let isPhone = props.manualLoginRequest?.verification == LoginVerification.PHONE;
    let isEmail = props.manualLoginRequest?.verification == LoginVerification.EMAIL;

  // Redirect to right modal based on auth proccess.
    const userStatus = user && user.status;
    const verifyEmailStatus = user && user.verifyEmailStatus;
     

    return(
        <form className={"form"} onSubmit={props.handleSubmit}>

            {props.error && (
                <div className={"alert alert-danger"}>
                    {props.error}
                </div>
            )}
            {isEmail && (
                <Field props={{label: "verifyEmail"}}
                       name="verifyEmail"
                       component={renderField} type="number"/>
            )}
            {isPhone && (
                <Field props={{label: "verifyPhoneNumber"}}
                       name="verifyPhoneNumber"
                       component={renderField} type="number"/>
            )}

            <BrandButton loading={props.submitting} type={"submit"} className={"btn btn-cta full-width"} disabled={props.invalid}>
                <span>{t("account." + (isPhone ? "verifyPhoneNumber" : "verifyEmail"))}</span>
            </BrandButton>

            {showResend && (
                <div className={"generic-text-button-container"} style={{padding: "10px 0", textAlign:"center"}}>
                    <p id="resend-question">{t("forms.verifyEmail.resendCode.title")}</p>
                    <span className={resendActive ? "text" : "text-disabled"}  onClick={() => {
                        if(resendActive) {
                            resendEmailVerificationCode(principal ?? "", props.manualLoginRequest?.verification ?? LoginVerification.EMAIL, settings).then((re) => {
                                setResendActive(false);
                                setTimeout(() => {
                                    setResendActive(true)
                                },120*1000)
                            })
                        }
                    }}>{resendActive ? t("forms.verifyEmail.resendCode.subTitle") : t("forms.verifyEmail.resendCode.altSubTitle")}</span>
                </div>
            )}
        </form>
        )
};


const mapStateToProps = ({user} : AppState) => {
    let tempUserId = user&& user.user && user.user.userUid;
    let tempUserId2 = user&& user.registration&& user.registration.userInfo&& user.registration.userInfo.userUid;
    let userUid = tempUserId === undefined ? tempUserId2 : tempUserId;
    
    if (userUid === undefined) {
        userUid = localStorage.getItem("userId") ?? undefined
    }

    return {
        userUid : userUid,
        manualLoginRequest: user.manualLoginRequest
    }
}


const form = reduxForm<any,{verifyEmail?: string, verifyPhoneNumber? : string}>({
    form: 'verifyEmail',
    validate : validateVerifyEmailForm,
    touchOnBlur : true,
    onSubmit : (req: {verifyEmail?: string, verifyPhoneNumber? : string}, dispatch: Dispatch, props: any) => {
        let userUid = props.userUid;
        return dispatch(verifyChannelCode(props.manualLoginRequest, userUid, req.verifyEmail ?? req.verifyPhoneNumber) as any)
    }
})(VerifyEmailForm);

export default connect(mapStateToProps)(form);
